module.exports = __webpack_public_path__ + "static/media/logo-internal.ccdd2b25.png";